$(document).ready(function(){

    //array of related videos
    let relatedVideosArr = [];

  

  function initRelatedVideos() {
  
    $('.js-related-videos-section').each(function () {
      var $parent = $(this);
      

      let searchQuery = $parent.data('search');

      var $latestVideoSection = false;
      if (searchQuery == "codectible-video" || searchQuery == "disruptor-video") {
        $latestVideoSection = $('.js-codectible-latest-video-section');
      }
      

      $.ajax({
        url: window.Shopify.routes.root + 'search?view=videoBlog-ajax&type=article&q=' + searchQuery,
        dataType: 'json',
        success: function(data){
          console.log(data);
          data = data.results;
          if ($latestVideoSection) {
            buildLatestVideoSection(data, $latestVideoSection);
          }
          buildRelatedVideosSection(data, $parent);
          buildRelatedVideosPopup(data);
        },
        error: function(err){
          console.log(err)
        }
      })
   })
  }

  function buildLatestVideoSection(data, $parent){
    if($parent.length == 0 || !data || data.length == 0) {
      $parent.hide();
      return data;
    }


    data.sort(function(a,b){
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.published_at) - new Date(a.published_at);
    });

    //get 1st element after sorting
    let latestVideo = data.shift();

    console.log(latestVideo);

    let videoProps = "autoplay playsinline loop muted controls"

    let $videoContainer = $parent.find('.js-codectible-latest-video-container');
    $videoContainer.append(`<video class="mobile-hide codectible-latest-video" src="${latestVideo.video}" ${videoProps} />`);
    $videoContainer.append(`<video class="desktop-hide codectible-latest-video" src="${latestVideo.mobile_video}" ${videoProps} />`);
    $videoContainer.addClass('video-loaded')
    
  }

  function buildRelatedVideosPopup(){

    let $el = $('#product-related-video-player-popup');

    var video = $(`<video-js id="product-related-video-player" class="video-js vjs-theme-sea">
    </video-js>
    `)
    //append video el
    $el.find('.product-related-video-player-object').prepend(video);
    //append playlist el
    let isMobile = $(window).width() > 768 ? false : true;
    if(!isMobile){
      $el.find('.product-related-video-player-container').append(`<div class="vjs-playlist"></div>`);
    }else{
      $el.find('.product-related-video-playlist-mobile').append(`<div class="vjs-playlist vjs-playlist-mobile"></div>`);
    }
    
    var vidOpts = {
      controls: true,
      preload: "none",
      autoPlay: true,
      playsinline: true,
      controlBar: {
        volumePanel: { inline: true },
      },
      fill: true,
      aspectRatio: '16:9'
    };

    videojs("product-related-video-player", vidOpts, function () {});

    var player = videojs("product-related-video-player");
    var playlist = [];
    var video_index = 0;
    //get playlist

    if(!relatedVideosArr || relatedVideosArr.length == 0) return false;

    for(let i = 0; i < relatedVideosArr.length; i++){
      let item = relatedVideosArr[i];
      var video = item.video
      var thumb = item.thumb
      var category = item.category
      var title = item.title
      var video_type = item.videoType
      
      var data = {
        name: title,
        description: category,
        video_type: video_type,
        autoplay: true,
        sources: [
          { src: video, type: 'video/mp4'}
        ],
        aspectRatio: "16:9",
        thumbnail:[
          { src: thumb }
        ]
      }

      playlist.push(data);
    }


    player.playlist(playlist, video_index);
    player.playlist.autoadvance(5);
    player.playlistUi({
      title: window.theme.strings.codectible.videoRelatedHeading, 
      title2: window.theme.strings.codectible.videoRelatedHeading,
      mobileTitle: window.theme.strings.codectible.videoRelatedHeading,
      isMobile: isMobile
    });

    let draggableElement = document.getElementById('product-related-video-player-draggable-el')
    let parentElement = document.getElementById('product-related-video-player-popup');


    interact(draggableElement)
      .draggable({
        startAxis: 'y',
        lockAxis: 'y',
        inertia: true,
        listeners: {
          move: dragMoveListener
        },
         modifiers: [
          interact.modifiers.snap({
            targets: [ { x: 0, y: 700, range: 100 }, { x: 0, y: 1, range: 100 } ],

          })
        ]
      })

      function dragMoveListener (event) {
        var target = event.target
        // keep the dragged position in the data-x/data-y attributes
        //get default height based on 10% of element
        let targetHeight = interact.getElementRect(event.target).height * -1;
        //var yDefault = targetHeight * 0.9;
        //starting height of video tab
        var yDefault = -190;
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
        var y = (parseFloat(target.getAttribute('data-y')) || yDefault) + event.dy

        if(y < targetHeight){
          y = targetHeight;
        }else if(y > yDefault) {
          y = yDefault
        }

        // translate the element
        target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

        // update the posiion attributes
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
      }
  }

  function buildRelatedVideosSection(data, $wrapper){
    var items = data
    if(!items || items.length == 0){
      return;
    }

    let priorityItems = [];
    let itemsCopy = [];

    //split array to priority and non priority

    for(let i = 0; i < items.length; i++){
      if(items[i].priority){
        priorityItems.push(items[i]);
      }else{
        itemsCopy.push(items[i]);
      }

      if(items[i].watch){
        initProductWatchIcon(items[i]);
      }
    }

    //sort by date
    itemsCopy.sort(function(a,b){
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.published_at) - new Date(a.published_at);
    });
    //sort by date;
    priorityItems.sort(function(a,b){
      return new Date(b.published_at) - new Date(a.published_at);
    });

    //merge two arrays priority first
    items = [...priorityItems, ...itemsCopy];

    console.log('related videos: ', items);

    var $relatedVideosSliderContainer = $wrapper.find('.product-related-videos-slider');

    //add articles to the slider
    for(var i = 0; i < items.length; i++){
      var article = items[i];
      var template = $(`<div class="product-related-information" >
        <a href="${article.url}">
          <div class="product-related-information-image-container">
            <img alt="${article.title}" src="${article.thumb}">
            <span data-src="#product-related-video-player-popup"
              data-title="${article.title}"
              data-thumb="${article.thumb}"
              data-category="${article.category}"
              data-video-type="${article.videoType}"
              data-video="${article.video}" class="product-related-video-play-icon js-product-related-video-play-icon">
              <span class="oi" data-glyph="play-circle"></span>
            </span>
          </div>
          <div class="product-related-information-text">
            <span class="product-related-information-category">${article.category}</span>
            <h4 class="product-related-information-title">${article.title}</h4>
          </div>
        </a>

      </div>`)

      $relatedVideosSliderContainer.append(template);
      relatedVideosArr.push(article);
    }

    let slickSettings = {
      accessibility: true,
      slidesToShow: 4,
      infinite: true,
      slidesToScroll: 1,
      prevArrow:
        '<a aria-label="Previous" class="prev-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 20 38"><path d="M4.068 18.649l15.466 16.105c.31.283.466.629.466 1.039 0 .41-.155.77-.466 1.08a1.412 1.412 0 0 1-1.038.424c-.41 0-.756-.141-1.038-.424L.466 19.708A1.373 1.373 0 0 1 0 18.648c0-.423.155-.776.466-1.059L17.458.424A1.412 1.412 0 0 1 18.496 0c.41 0 .755.141 1.038.424.31.282.466.636.466 1.06 0 .423-.155.776-.466 1.059L4.068 18.649z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
      nextArrow:
        '<a aria-label="Next" class="next-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 20 38"><path d="M15.932 18.649L.466 2.543A1.35 1.35 0 0 1 0 1.505c0-.41.155-.77.466-1.081A1.412 1.412 0 0 1 1.504 0c.41 0 .756.141 1.038.424l16.992 17.165c.31.283.466.636.466 1.06 0 .423-.155.777-.466 1.06L2.542 36.872a1.412 1.412 0 0 1-1.038.424c-.41 0-.755-.141-1.038-.424A1.373 1.373 0 0 1 0 35.813c0-.423.155-.776.466-1.059L15.932 18.65z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    }

    $relatedVideosSliderContainer.on('init', function(){
      $wrapper.addClass('is-initializing');
      if($(window).width() > 768 && $relatedVideosSliderContainer.hasClass('slick-initialized')){
        $(window).trigger('resize');
      }
      setTimeout(function(){
        $wrapper.removeClass('is-initializing');
        $wrapper.addClass('initialized');
        if($(window).width() > 768 && $relatedVideosSliderContainer.hasClass('slick-initialized')){
          $relatedVideosSliderContainer.slick('refresh')
        }
      }, 2000)
    })

    $relatedVideosSliderContainer.slick(slickSettings)

    $(window).on('resize', throttle(function() {
      if( $(window).width() > 768 &&  !$relatedVideosSliderContainer.hasClass('slick-initialized')) {
            $relatedVideosSliderContainer.slick(slickSettings);
        }
    }, 500));

    $wrapper.show();

  }

  function init(){
    //initRelatedVideos();
  }
  

  init();
})


var Codectible = (function() {
  const url = window.theme.apiUrl;

  function init(){
    initEventListeners();
  }

  function initEventListeners(){
    $('[data-codectible-follow-button]').on('click.codectible', handleFollowClick)

    $('[data-codectible-unfollow-button]').on('click.codectible', handleUnfollowClick)
  }


  function handleFollowClick(event){
    //let $this = $(this);
    event.preventDefault();
    $this = $(event.currentTarget);

    let data = {
      customerId: $this.data('customer'),
      codectibleId: $this.data('id')
    }

    let successCb = function(data){
      console.log('Follow Successful', data);
      $this.addClass('following');
      $this.removeAttr('data-codectible-follow-button');
      $this.attr('data-codectible-unfollow-button', "");
      $this.off('click.codectible');
      $this.on('click.codectible', handleUnfollowClick)
      updateFollowersCount(data.followersCount); 
    }

    let errCb = function(error){
      console.log("follow error: ", error)
    }

    codectibleFollow(data, successCb, errCb, null)
  }

  function handleUnfollowClick(event){
    event.preventDefault();
    $this = $(event.currentTarget);

    let data = {
      customerId: $this.data('customer'),
      codectibleId: $this.data('id')
    }

    let successCb = function(data){
      console.log('Unfollow Successful', data);
      $this.removeClass('following');
      $this.removeAttr('data-codectible-unfollow-button');
      $this.attr('data-codectible-follow-button', "");
      $this.off('click.codectible');
      $this.on('click.codectible', handleFollowClick)
      updateFollowersCount(data.followersCount);
    }

    let errCb = function(error){
      console.log("unfollow error: ", error)
    }

    codectibleUnfollow(data, successCb, errCb, null)
  }

  function codectibleFollow(data, cb, errCb, completeCb){
    $.ajax({
      type: "POST",
      url: url + "/api/codectible/follow",
      data: data,
      success: function (data) {
        cb(data);
      },
      error: function (err) {
        console.log("error:", err);
        errCb(err);
      },
      complete: function () {
        if (completeCb instanceof Function) {
          completeCb();
        }
      },
    });
  }

  function codectibleUnfollow (data, cb, errCb, completeCb){
    //vars - codectibleId, customerId
      $.ajax({
      type: "POST",
      url: url + "/api/codectible/unfollow",
      data: data,
      success: function (data) {
        cb(data);
      },
      error: function (err) {
        console.log("error:", err);
        errCb(err);
      },
      complete: function () {
        if (completeCb instanceof Function) {
          completeCb();
        }
      },
    });
  }

  function updateFollowersCount(count){
    let $container = $('.js-codectible-followers-count');
    if(count < 20){ 
      $container.hide();
    }else{
      $container.show(); 
    }
    $container.text(count);
  }

  init();

})();

//codectible newsletter button
document.querySelector('.js-codectible-newsletter-subscribe').addEventListener('click', function (){
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Rqa67E']);
});